module.exports = __webpack_public_path__ + "static/media/rest.86ac770c.svg";